import * as TypeAction from './actionTypes'
import { actionSincCRUD, actionSyncListObj } from 'scorpion-core';
import { salva, manterSincronizacao } from './api';
import { currentUser, userUid } from '../../../firebase'
export const salvar = (perfil, retorno) => (dispatch) => {
    if (!perfil.uid) {
        perfil.uid = userUid()
    }
    actionSincCRUD(salva(perfil), TypeAction.SALVAR, dispatch, retorno)
}

export const buscar = () => (dispatch) => {
    manterSincronizacao(actionSyncListObj(TypeAction.BUSCAR, dispatch, (perfil) => {        
        if (perfil === null) {
            const user = currentUser()
            const { displayName, email, emailVerified, phoneNumber, photoURL, metadata: { creationTime } } = user;
            let perfil = { uid: user.uid, nome: displayName, email, emailVerified, telefone: phoneNumber, photoURL, creationTime }
            console.log('novoPerfil', perfil);

            salvar(perfil)(dispatch)
        }

    }));
}






// WEBPACK FOOTER //
// ./src/routes/private/PerfilUsuario/actions.js